import { IRecording } from '@24sens/ecg01-recordings';
import { TileComponent } from '@24sens/ui';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SignalDetails } from '../signal/SignalDetails';
import { CardAvatar } from './CardAvatar';
import { SeenButton } from './PlotCardActions';

export interface PlotCardProps {
  entry: IRecording;
}

export const PlotCard: React.FC<PlotCardProps> = ({ entry, ...props }) => {
  const { t } = useTranslation();

  return (
    <TileComponent
      testId={'PlotCardHeader_' + entry.id}
      image={<CardAvatar icon={<BarChartIcon />} />}
      primaryText={entry.patient_name ?? ''}
      secondaryText={t('timeline.plotCard.subtitle', {
        start_time: new Date(entry.start_time),
        end_time: entry.end_time ? new Date(entry.end_time) : '',
      })}
      headerAction={<SeenButton entry={entry} />}
    >
      {entry.outputfile ? (
        <SignalDetails recordingId={entry.id} />
      ) : (
        <Typography variant={'h5'}>{t('timeline.plotCard.dataMissing')}</Typography>
      )}
    </TileComponent>
  );
};
